import { render, staticRenderFns } from "./recoveryForm.vue?vue&type=template&id=2ef38ea2&scoped=true&"
import script from "./recoveryForm.vue?vue&type=script&lang=js&"
export * from "./recoveryForm.vue?vue&type=script&lang=js&"
import style0 from "./recoveryForm.vue?vue&type=style&index=0&id=2ef38ea2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef38ea2",
  null
  
)

export default component.exports